import React from "react";
import "..//../index.css";

const LoadingOverlay = () => {
  return (
    <div className="loading-overlay">
      <div className="loader"></div>
    </div>
  );
};

export default LoadingOverlay;
